<template>
  <div ref="readyRoot" class="ready-root">
    <div class="ready-content">
      <div class="ready-text">
        Please do equipment check before entering the test:
      </div>
      <div style="color: #1b213d; margin-top: 20px">
        The authorization on this preparation page is for equipment check only.
        You need re-authorize your camera and screen sharing after you enter the
        test page.
      </div>
      <div class="check-container">
        <div class="checkItem">
          <div class="checkImteText">
            <i
              v-if="clockCheckLoading"
              class="el-icon-loading ready-clock-icon"
              aria-hidden="true"
            ></i>
            <img
              v-else-if="clockStatus === 'ok'"
              src="../../assets/device_success.png"
              class="ready-img"
            />
            <img
              v-else
              src="../../assets/device_error.png"
              class="ready-img"
            />
            <div class="ready-check-copy">
              <strong>Computer Time Check</strong>
              <small>{{ clockStatusText }}</small>
            </div>
          </div>
          <div
            v-if="clockStatus !== 'ok' && !clockCheckLoading"
            class="ready-restart"
            @click="checkLocalClock(false)"
          >
            Check Again
          </div>
        </div>
        <div class="checkItem">
          <div class="checkImteText">
            <img
              v-if="device_camera_status"
              src="../../assets/device_success.png"
              class="ready-img"
            />
            <img
              v-if="!device_camera_status"
              src="../../assets/device_error.png"
              class="ready-img"
            />
            <div class="ready-text" style="margin-left: 15px; font-size: 20px">
              Camera Sharing Check
            </div>
          </div>
          <div
            v-if="!device_camera_status"
            class="ready-restart"
            @click="checkDevice"
          >
            Reopen
          </div>
        </div>

        <div class="checkItem">
          <div class="checkImteText">
            <img
              v-if="device_screen_status"
              src="../../assets/device_success.png"
              class="ready-img"
            />
            <img
              v-if="!device_screen_status"
              src="../../assets/device_error.png"
              class="ready-img"
            />
            <div class="ready-text" style="margin-left: 15px; font-size: 20px">
              [Full Screen Sharing*]Check
            </div>
          </div>
          <div
            v-if="!device_screen_status"
            class="ready-restart"
            @click="checkDevice"
          >
            Reopen
          </div>
        </div>
        <div class="checkItem">
          <div class="checkImteText">
            <img
              v-if="idCheckSuccess"
              src="../../assets/device_success.png"
              class="ready-img"
            />
            <img
              v-if="!idCheckSuccess"
              src="../../assets/device_error.png"
              class="ready-img"
            />
            <div class="ready-text" style="margin-left: 15px; font-size: 20px">
              [ID Document **]Photo Upload
            </div>
          </div>
          <div class="ready-restart" @click="doShowIdDialog">
            Upload photo proof of identity
          </div>
        </div>
      </div>
      <div v-if="status && cameraStream" class="ready-proctor-check">
        <ProctorMonitor
          :stream="cameraStream"
          :template-id="template_id"
          :project-code="project_code"
          mode="ready"
          :log-speech="false"
          @face-status-change="handleReadyFaceStatus"
        />
        <p>
          Keep one face visible and speak briefly to verify the microphone waveform.
          The preparation page previews these checks but does not save speech events or audio.
        </p>
      </div>
      <div style="color: #1b213d; margin-top: 50px; line-height: 200%">
        *You must share the [ full screen ],but not only single window or
        browser tab. <br />
        **ID Document refers to any official document that proves a test taker's
        identity ( e.g. National ID card ,driver license ,School ID card
        ,National Security Card ,Passport ,etc.).
        <br />When photographing make sure the photo and name side of your ID
        document is clearly visible in front of the camera, To avoid losing
        focus, do not put it too close to the camera. <br />The photograph is
        only for use of test proctoring and it will be deleted from the server
        after 5 business days .
      </div>
      <div style="color: #1b213d; margin-top: 20px; line-height: 200%">
        Attention: you must use a desktop computer (Windows or Mac). Mobile
        phones and tables are not supported. You also must use Google Browser
        Chrome and authorize your computer and browser to share your camera and
        full screen.<br />Do not how to authorize your camera and screen
        sharing? Please view<a
          href="https://ap.learningfirst.tech/Equipment%20Setting%20Guide%20English.pdf"
          target="_blank"
          ><span
            style="
              background-color: white;
              color: #1b213d;
              margin-left: 5px;
              padding: 4px;
              border-radius: 4px;
            "
            >[Equipment Setting Guide]</span
          ></a
        >
      </div>
      <div style="color: #1b213d; margin-top: 20px">
        All screen cuttings will be recorded and reviewed by proctors.
      </div>
      <div class="ready-go-exam" @click="goExam">Enter Test</div>
    </div>
    <canvas
      id="cameraCanvas"
      :width="cameraOptions.video.width"
      :height="cameraOptions.video.height"
      style="display: none"
    ></canvas>
    <canvas
      id="screenCanvas"
      :width="screenOptions.video.width"
      :height="screenOptions.video.height"
      style="display: none"
    ></canvas>

    <el-dialog
      :visible.sync="showUploadIdDialog"
      width="70%"
      title="Take"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="!idUploadLoading"
    >
      <el-form>
        <div class="camera-box">
          <div style="display: flex; flex-direction: row">
            <div>
              <div style="margin-bottom: 10px">Preview</div>
              <video
                id="id-video"
                :width="idVideoWidth"
                :height="idVideoHeight"
              ></video>
            </div>
            <div style="margin-left: 10px">
              <div style="margin-bottom: 10px">Photo</div>
              <canvas
                id="id-canvas"
                :width="idVideoWidth"
                :height="idVideoHeight"
              ></canvas>
            </div>
          </div>
          <p class="camera-p">
            {{
              'Note: please put your ID document in the middle and keep the camera focused with photo and name clearly visible. Press "take" button to confirm'
            }}
          </p>
          <div style="margin-top: 15px; display: flex; flex-direction: row">
            <el-button
              type="primary"
              @click="setImage"
              :disabled="idUploadLoading"
            >{{
              imgSrc ? "Retake" : "Take"
            }}</el-button>
            <el-button
              type="primary"
              @click="setFileUpload"
              v-if="imgSrc"
              :loading="idUploadLoading"
              :disabled="idUploadLoading"
              >{{ idUploadLoading ? "Submitting..." : "Submit" }}</el-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getExamEvidenceQiniuToken,
  checkIsUploadTest,
  uploadStudentIdCard,
  getStudentIdCard,
  recordPreparedExamEntry,
} from "../../api/index";
import { getProjectCode, resolveAndSetExamProjectCode, getUserId } from "../../utils/store";
import { measureExamClock, buildClockErrorMessage } from "../../utils/server-time";
import * as qiniu from "qiniu-js";
import ProctorMonitor from "./ProctorMonitor";

const ID_PHOTO_MIME_TYPE = "image/jpeg";
const ID_PHOTO_QUALITY = 0.82;
const EXAM_EVIDENCE_BASE_URL = "https://ap.learningfirst.io/";

export default {
  name: "ExamReady",
  components: {
    ProctorMonitor,
  },
  data() {
    return {
      imgSrc: "",
      showUploadIdDialog: false,
      cameraOptions: {
        audio: {
          channelCount: 1,
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
        video: {
          width: 640,
          height: 480,
          aspectRatio: 4 / 3,
          facingMode: "user",
          resizeMode: "none",
        },
      },
      screenOptions: {
        audio: false,
        video: { width: 1280, height: 720 },
      },
      timer: "",
      status: false,
      have_exam: false,
      device_camera_status: true,
      device_screen_status: true,
      template_id: this.$route.query.template_id,
      start_time: this.$route.query.start_time,
      end_time: this.$route.query.end_time,
      event_type: this.$route.query.event_type,
      type: this.$route.query.type,
      videoTime: this.$route.query.videoTime,
      exam_mode: this.$route.query.exam_mode || 'relay', // 'relay' or 'individual'
      exam_name: this.$route.query.exam_name || '',
      project_code: resolveAndSetExamProjectCode(this.$route.query.project_code),
      cameraVideo: null, // 摄像头视频容器
      screenVideo: null, // 屏幕视频容器
      cameraStream: null, // 摄像头视频流
      screenStream: null, // 屏幕视频流

      idCanvas: undefined,
      idVideo: undefined,
      idContext: undefined,
      idVideoWidth: 400,
      idVideoHeight: 300,
      idCheckSuccess: false,
      idStream: null,
      idVideoStream: null,
      idUploadLoading: false,
      clockStatus: "checking",
      clockCheckLoading: false,
      clockResult: null,
      faceCheckReady: false,
      faceCheckStatus: "loading",
      preparedEntrySaving: false,
    };
  },
  computed: {
    clockStatusText() {
      if (this.clockCheckLoading || this.clockStatus === "checking") {
        return "Checking against the exam server...";
      }
      if (this.clockStatus === "ok") return "Server time verified";
      if (this.clockStatus === "invalid" && this.clockResult) {
        return buildClockErrorMessage(this.clockResult.clockSkewMs);
      }
      return "Server time could not be verified";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.resetReadyScrollPosition();
    });
    this.checkLocalClock(false);
    this.checkStudentExam();
    this.startCheckOnline();
    this.checkDevice();
    this.checkStudentId();
  },
  beforeDestroy() {
    console.log("---beforeDestroy---");
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.clearAllResource();
  },
  methods: {
    resetReadyScrollPosition() {
      window.scrollTo(0, 0);
      if (this.$refs.readyRoot) {
        this.$refs.readyRoot.scrollTop = 0;
      }
    },
    async checkLocalClock(showDialog) {
      if (this.clockCheckLoading) return false;
      this.clockCheckLoading = true;
      this.clockStatus = "checking";
      try {
        const result = await measureExamClock();
        this.clockResult = result;
        this.clockStatus = result.valid ? "ok" : "invalid";
        if (!result.valid && showDialog) {
          await this.$alert(buildClockErrorMessage(result.clockSkewMs), "Computer Time Check", {
            confirmButtonText: "Check Again",
            type: "warning",
          });
        }
        return result.valid;
      } catch (error) {
        console.error("Computer clock verification failed", error);
        this.clockResult = null;
        this.clockStatus = "unavailable";
        if (showDialog) {
          await this.$alert(
            "The exam server time could not be verified. Check your network connection and try again.",
            "Computer Time Check",
            { confirmButtonText: "Check Again", type: "warning" }
          );
        }
        return false;
      } finally {
        this.clockCheckLoading = false;
      }
    },
    checkStudentId() {
      getStudentIdCard(getUserId(), this.template_id, this.project_code).then(
        (res) => {
          var result = res.data.data;
          if (result && result.uploaded) {
            this.idCheckSuccess = true;
          }
        }
      );
    },
    doShowIdDialog() {
      this.imgSrc = "";
      this.showUploadIdDialog = true;
      this.$nextTick(() => {
        this.getCompetence();
      });
    },
    setImage() {
      var _this = this;
      // 点击，canvas画图
      _this.idContext.drawImage(
        _this.idVideo,
        0,
        0,
        _this.idVideoWidth,
        _this.idVideoHeight
      );
      // 获取图片base64链接
      var image = this.idCanvas.toDataURL(
        ID_PHOTO_MIME_TYPE,
        ID_PHOTO_QUALITY
      );
      _this.imgSrc = image;
    },
    async setFileUpload() {
      if (this.idUploadLoading || !this.imgSrc) {
        return;
      }

      this.idUploadLoading = true;
      var time = new Date();
      var file_name = "id_pic_" + time.getTime() + ".jpg";
      var file = this.dataURLtoFile(this.imgSrc, file_name);
      try {
        const tokenResponse = await getExamEvidenceQiniuToken(
          "id",
          this.project_code,
          this.template_id,
          getUserId()
        );
        const responseData = tokenResponse && tokenResponse.data;
        const tokenData = responseData && responseData.data;
        if (
          !responseData ||
          responseData.code !== 0 ||
          !tokenData ||
          !tokenData.token ||
          !tokenData.key_prefix
        ) {
          throw new Error("Failed to get ID photo upload token");
        }

        const objectKey = tokenData.key_prefix + time.getTime() + ".jpg";
        const uploadResult = await new Promise((resolve, reject) => {
          qiniu.upload(file, objectKey, tokenData.token).subscribe({
            error: reject,
            complete: resolve,
          });
        });
        await this.doSavePic(EXAM_EVIDENCE_BASE_URL + uploadResult.key);
      } catch (error) {
        console.error("ID photo upload failed", error);
        this.$message.error("ID Photo Upload failed. Please try again!");
      } finally {
        this.idUploadLoading = false;
      }
    },
    doSavePic(pic_url) {
      return uploadStudentIdCard(
        getUserId(),
        this.template_id,
        this.project_code,
        pic_url
      ).then(() => {
        this.idCheckSuccess = true;
        this.$message.success("ID Photo Upload Successful");
        this.showUploadIdDialog = false;
        this.clearIdStream();
      });
    },
    dataURLtoFile(dataUrl, fileName) {
      var arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },
    getCompetence() {
      // 初始化的时候直接让为空
      this.imgSrc = "";
      var _this = this;
      this.idCanvas = document.getElementById("id-canvas");
      this.idContext = this.idCanvas.getContext("2d");
      this.idVideo = document.getElementById("id-video");
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia;
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      var constraints = {
        audio: false,
        video: {
          width: this.idVideoWidth,
          height: this.idVideoHeight,
          transform: "scaleX(-1)",
        },
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          _this.idStream = stream;
          if ("srcObject" in _this.idVideo) {
            _this.idVideo.srcObject = stream;
            _this.idVideoStream = stream;
          } else {
            _this.idVideo.src = window.URL.createObjectURL(stream);
            _this.idVideoStream = stream;
          }
          _this.idVideo.onloadedmetadata = function () {
            _this.idVideo.play();
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async goExam() {
      if (!(await this.checkLocalClock(true))) return;

      if (this.have_exam) {
        this.$message.error("You have already completed the test.");
        return;
      }

      if (!this.status) {
        this.$message.error(
          "You can not enter the test as your equipment is not set up correctly."
        );
        return;
      }

      if (!this.faceCheckReady) {
        await this.$alert(
          this.getFaceEntryBlockedMessage(),
          "Show your face before entering",
          { confirmButtonText: "Check Camera Position", type: "warning" }
        );
        return;
      }

      if (!this.idCheckSuccess) {
        this.$message.error("Please upload your ID document photo first.!");
        return;
      }

      if (this.type && this.type == "video") {
        let videoTime = this.videoTime;
        let template_id = this.template_id;
        let url = this.$router.resolve({
          path: "VideoPlay",
          query: {
            videoTime: videoTime,
            template_id: template_id,
          },
        });
        window.open(url.href, "_blank");
        return;
      }

      var currentTime = this.clockResult.serverTimeMs;

      if (this.event_type == "Formal") {
        if (this.start_time > currentTime) {
          this.$message({
            message: "The test has not started. Please wait for a while.",
            type: "warning",
          });
          return;
        }

        if (this.exam_mode !== 'individual' && this.end_time && Number(this.end_time) < currentTime) {
          this.$message({
            message:
              "The test entry time is over. You cannot enter the test room now.",
            type: "warning",
          });
          return;
        }
      }

      if (this.preparedEntrySaving) return;
      this.preparedEntrySaving = true;
      const entryTime = Date.now();
      const clientEntryId = `prepared-entry-${entryTime}-${Math.random().toString(36).slice(2, 12)}`;
      const entryProjectCode = String(
        this.project_code || this.$route.query.project_code || getProjectCode() || ""
      ).trim();
      try {
        const response = await recordPreparedExamEntry({
          student_id: getUserId(),
          project_code: entryProjectCode,
          template_id: this.template_id,
          client_entry_id: clientEntryId,
        }, {
          timeout: 8000,
          skipNetworkErrorMessage: true,
        });
        const result = response && response.data ? response.data : null;
        if (!result || result.code !== 0) {
          const entryError = new Error(
            result && result.msg ? result.msg : "Exam entry was rejected"
          );
          entryError.examEntryCode = result && result.code;
          throw entryError;
        }
      } catch (error) {
        console.error("Unable to record the prepared exam entry", error);
        if (error && error.examEntryCode === -12) {
          await this.$alert(error.message, "IP address already used", {
            confirmButtonText: "OK",
            type: "warning",
            showClose: false,
          });
        } else {
          this.$message.error(
            error && error.message && (error.examEntryCode === -13 || error.examEntryCode === -1)
              ? error.message
              : "The exam server could not record your entry. Check your connection and try again."
          );
        }
        this.preparedEntrySaving = false;
        return;
      }

      if (this.exam_mode === 'individual') {
        this.$router.replace({
          path: '/exam',
          query: {
            template_id: this.template_id,
            invigilateStatus: false,
            exam_mode: 'individual',
            project_code: this.project_code,
          },
        });
      } else {
        this.$router.replace({
          path: "/waiting-room",
          query: {
            template_id: this.template_id,
            exam_name: this.exam_name,
            project_code: this.project_code,
          },
        });
      }
    },
    async checkDevice() {
      if (this.status) {
        return;
      }
      this.clearAllResource();
      // 判断浏览器是否有权限
      if (
        !navigator ||
        !navigator.mediaDevices ||
        !navigator.mediaDevices.getUserMedia
      ) {
        this.$message.error("Your browser does not support camera sharing.");
        return console.log("浏览器不支持访问摄像头!");
      }
      if (
        !navigator ||
        !navigator.mediaDevices ||
        !navigator.mediaDevices.getDisplayMedia
      ) {
        this.$message.error("Your browser does not support screen sharing");
        return console.log("浏览器不支持屏幕录制!");
      }
      this.cameraVideo = document.createElement("video");
      this.screenVideo = document.createElement("video");
      // 视频流
      const loading = this.$loading({
        lock: true,
        text: "Getting camera authorization..",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let stream = await navigator.mediaDevices
        .getUserMedia(this.cameraOptions)
        .catch((err) => {
          this.$message.error(` error:${err}`);
          this.device_camera_status = false;
          this.clearAllResource();
          return;
        })
        .finally(() => {
          loading.close();
        });
      if (!stream) return;
      this.cameraStream = stream;
      this.cameraVideo.srcObject = stream;
      this.cameraVideo.play();
      loading.close();
      // 屏幕流
      const loading1 = this.$loading({
        lock: true,
        text: "Getting screen authorization...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let stream1 = await navigator.mediaDevices
        .getDisplayMedia(this.screenOptions)
        .catch((err) => {
          this.$message.error(` error:${err}`);
          this.device_screen_status = false;
          this.clearAllResource();
          return;
        })
        .finally(() => {
          loading1.close();
        });
      if (!stream1) return;
      this.device_camera_status = true;
      if (
        stream1 &&
        stream1.getVideoTracks()[0].getSettings().displaySurface !== "monitor"
      ) {
        this.$alert(
          "Please choose to share the full screen",
          "Screen authorization failed",
          {
            confirmButtonText: "OK",
            type: "error",
          }
        );
        this.device_screen_status = false;
        this.clearAllResource();
        return;
      }
      this.device_screen_status = true;
      this.screenStream = stream1;
      this.screenVideo.srcObject = stream1;
      this.screenVideo.play();
      this.status = true;
      loading.close();
    },
    handleReadyFaceStatus(result) {
      this.faceCheckReady = Boolean(result && result.valid);
      this.faceCheckStatus = result && result.status ? result.status : "loading";
    },
    getFaceEntryBlockedMessage() {
      const messages = {
        missing: "The camera cannot detect your face. Sit in front of the camera and wait for the green confirmation.",
        multiple: "More than one face is visible. Only the registered candidate may remain in view.",
        error: "Face detection did not start correctly. Check your connection and run the device check again.",
        loading: "Face detection is still loading. Keep one face visible and wait for the green confirmation.",
      };
      return messages[this.faceCheckStatus] || messages.missing;
    },
    startCheckOnline() {
      this.timer = setInterval(() => {
        if (!this.cameraStream || !this.cameraStream.active) {
          this.device_camera_status = false;
          if (this.status) {
            this.clearAllResource();
          }
          this.status = false;
        }
        if (!this.screenStream || !this.screenStream.active) {
          this.device_screen_status = false;
          if (this.status) {
            this.clearAllResource();
          }
          this.status = false;
        }
      }, 1000);
    },
    clearIdStream() {
      if (this.idStream && this.idStream.getTracks) {
        this.idStream.getTracks().forEach((track) => track.stop());
        this.idStream = null;
      }
      this.idVideoStream = null;
    },
    clearAllResource() {
      this.clearIdStream();
      if (this.cameraStream && this.cameraStream.getTracks) {
        this.cameraStream.getTracks().forEach((track) => track.stop());
      }
      if (this.screenStream && this.screenStream.getTracks) {
        this.screenStream.getTracks().forEach((track) => track.stop());
      }
      this.cameraVideo = null;
      this.screenVideo = null;
      this.cameraStream = null;
      this.screenStream = null;
      this.status = false;
      this.faceCheckReady = false;
      this.faceCheckStatus = "loading";
    },
    checkStudentExam() {
      checkIsUploadTest(this.template_id, getUserId()).then((res) => {
        var result = res.data;
        this.have_exam = result;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ready-go-exam {
  cursor: pointer;
  margin-top: 5vh;
  text-align: center;
  width: 180px;
  height: 40px;
  background-color: #e64f29;
  opacity: 1;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: white;
}

.ready-img {
  width: 32px;
  height: 32px;
}

.ready-clock-icon {
  width: 32px;
  color: #072d76;
  font-size: 28px;
  text-align: center;
}

.ready-check-copy {
  min-width: 0;
  margin-left: 12px;
  strong,
  small { display: block; }
  strong { color: #1b213d; font-size: 17px; }
  small { margin-top: 5px; color: #5f6880; font-size: 11px; line-height: 1.35; }
}

.ready-proctor-check {
  max-width: 680px;
  margin-top: 24px;
  p { margin: 10px 0 0; color: #4d566d; font-size: 13px; line-height: 1.55; }
}

.ready-restart {
  display: inline-block;
  cursor: pointer;
  background-color: #072d76;
  color: white;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  padding: 6px 12px;
  margin-top: 10px;
  margin-right: 10px;
}

.ready-text {
  font-size: 32px;
  color: #1b213d;
  font-family: "Microsoft YaHei";
  font-weight: bold;
}

.ready-root {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;
  background-image: url("../../assets/magin_right_bg.png");
  background-color: transparent;
  background-size: cover;

  .ready-content {
    width: 1100px;
    max-width: calc(100% - 40px);
    margin: 0 auto;
  }

  .check-container {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .checkItem {
      border: 3px solid #e64f29;
      padding: 20px;
      box-sizing: border-box;
      width: 24%;
      .checkImteText {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }
}
</style>
